import moment from 'moment';
import store from 'store';
import { getBrowserLanguageWithoutCountry } from 'js/helpers/localization';
import { SUPPORTED_LOCALIZATION_LANGUAGES, LANGUAGE_CODE_SPANISH as LANGUAGE_FALLBACK_DEFAULT } from 'js/constants/localization';
var CURRENT_LANGUAGE_COOKIE_NAME = 'currentLanguage';
var browserLanguage = store.get(CURRENT_LANGUAGE_COOKIE_NAME) || getBrowserLanguageWithoutCountry();
var originalLanguage = SUPPORTED_LOCALIZATION_LANGUAGES.indexOf(browserLanguage) !== -1 ? browserLanguage : LANGUAGE_FALLBACK_DEFAULT;
updateCurrentLanguageCookie(originalLanguage);
updateMomentLocale(originalLanguage);
var STATE_DEFAULT = {
  currentLanguage: originalLanguage
};
export var CURRENT_LANGUAGE_UPDATE = 'CURRENT_LANGUAGE_UPDATE';
export default function localization() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CURRENT_LANGUAGE_UPDATE:
      updateCurrentLanguageCookie(action.language);
      updateMomentLocale(action.language);
      return Object.assign({}, state, {
        currentLanguage: action.language
      });

    default:
      return state;
  }
}

function updateCurrentLanguageCookie(language) {
  store.set(CURRENT_LANGUAGE_COOKIE_NAME, language);
}

function updateMomentLocale(language) {
  moment.locale(language);
}